// extracted by mini-css-extract-plugin
module.exports = {"reportPageContainer":"report-page-module__reportPageContainer___3f-4W","right":"report-page-module__right___3Wzrm","center":"report-page-module__center___27XXu"};